import { color } from "helpers/styled"
import PropTypes from "prop-types"
import styled from "styled-components"

const DotContainer = styled.ul`
  display: flex;
  justify-content: center;
  width: auto;
  margin: 0px auto;
  padding: 0;

  > li {
    display: inline-flex;
    justify-content: center;
    margin: 0px 5px;
  }
`

const Dot = styled.button`
  width: 8px;
  height: 8px;
  padding: 0;
  margin: 0;
  border: none;
  border-radius: 50%;
  background: ${color("gray")};
  opacity: 0.2;
  cursor: pointer;

  ${({ selected }) =>
    selected &&
    `
    margin-top: -2px;
    width: 12px;
    height: 12px;
    background: ${color("deepPink")};
    opacity: 1;
  `}
`

function Dots({ selectedIndex, snaps, handleClick }) {
  if (snaps.length <= 1) return null

  return (
    <DotContainer>
      {snaps.map((snap, i) => (
        <li key={snap}>
          <Dot aria-label={i} selected={i === selectedIndex} onClick={() => handleClick(i)} />
        </li>
      ))}
    </DotContainer>
  )
}

Dots.propTypes = {
  handleClick: PropTypes.func.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  snaps: PropTypes.array.isRequired
}

export default Dots
